import { render } from "./LegacyEmailField.vue?vue&type=template&id=8975b406"
import script from "./LegacyEmailField.vue?vue&type=script&lang=js"
export * from "./LegacyEmailField.vue?vue&type=script&lang=js"
script.render = render

export default script